import { makeAutoObservable } from "mobx"
import axios, { AxiosError } from "axios"

import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { securityApi } from "@src/shared/api"
import { router } from ".."

export class ChangePasswordStore {
  changePassword = async (identity: {
    confirm_password: string
    current_password: string
    new_password: string
  }) => {
    this.isLoading = true

    return securityApi
      .changePassword(identity)
      .then((response) => router.navigate(paths.settings).then(() => response))
      .finally(() => {
        this.isLoading = false
      })
  }

  isLoading = false

  constructor() {
    makeAutoObservable(this)
  }
}
